<ng-container *ngIf="currentTab$ | async">
	<flx-tabs [tabs]="tabs" [currentStep$]="currentTab$" [externalPages]="true" (outputEventStream)="handleTab($event)">
		<flx-key-value-list [data$]="displayData$"> </flx-key-value-list>
	</flx-tabs>
</ng-container>
